module.exports = __webpack_public_path__ + "static/media/amsterdam.3c178e32.jpg";